import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AcepActeur } from "app/modules/models/acepActeur.type";
import { Company } from "app/modules/models/company.type";
import { environment } from "environments/environment";
import { map, Observable, ReplaySubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    private _company: ReplaySubject<Company> = new ReplaySubject<Company>(1);
    private _reload: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
    private _selectedCompany: ReplaySubject<Company> = new ReplaySubject<Company>(1);

    set company(value: Company) {
        this._company.next(value);
    }

    get company$(): Observable<Company> {
        return this._company.asObservable();
    }

    set reload(value: boolean) {
        this._reload.next(value);
    }

    get reload$(): Observable<boolean> {
        return this._reload.asObservable();
    }

    get selectedCompany$(): Observable<Company> {
        return this._selectedCompany.asObservable();
    }

    set selectedCompany(value: Company) {
        this._selectedCompany.next(value);
    }

    constructor(private _http: HttpClient) {
    }

    public getCompanyBySiret(siret: string, codeClient: string): any {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.getCompanyBySiret + siret + '/' + codeClient;
        return this._http.get(route).pipe(map(res => res as any));
    }

    getCompaniesBySirets(requests: any[]): Observable<any[]> {
        const route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.getCompaniesBySirets;
        return this._http.post<any[]>(route, requests, this.prepareHeader());
    }

    public getCompanyInformation(siren: string): any {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.insee_siren + siren;
        return this._http.get(route).pipe(map(res => res as any));
    }

    public GetActorsByType(type: string): Observable<AcepActeur[]> {
        const route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.getActorsByType + type;
        return this._http.get(route, this.prepareHeader()).pipe(map(res => res as AcepActeur[]));
    }

    public addNewCompany(company: Company): Observable<Company> {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.controllerRoute;
        return this._http.post(route, company, this.prepareHeader()).pipe(map(res => res as Company));
    }

    public importCompanyFromAcep(company: Company): Observable<Company> {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.importFromAcep;
        return this._http.post(route, company, this.prepareHeader()).pipe(map(res => res as Company));
    }

    public changeCrmPartenerStatus(companyId: string, status: boolean): Observable<boolean> {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.changeCrmPartenerStatus + companyId + "/" + status;
        return this._http.get(route).pipe(map(res => res as boolean));
    }
    public changeEpPartenerStatus(companyId: string, status: boolean): Observable<boolean> {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.changeEPPartenaireStatus + companyId + "/" + status;
        return this._http.get(route).pipe(map(res => res as boolean));
    }

    public updateCompany(company: Company) {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.update;
        return this._http.put(route, company, this.prepareHeader()).pipe(map(res => res as Company));
    }

    getCompany(companyId: string) {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.getById + companyId;
        return this._http.get(route).pipe(map(res => res as any));
    }

    getAllCompanies(): Observable<Company[]> {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.getAll;
        return this._http.get(route).pipe(map(res => res as Company[]));
    }

    getAllActiveCompanies(): Observable<Company[]> {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.getAllActive;
        return this._http.get(route).pipe(map(res => res as Company[]));
    }

    SetCompanySettings(company: Company) {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.companySettings;
        return this._http.put(route, company).pipe(map(res => res as any));
    }

    getCompanySettings(companyId: string) {
        var route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.companySettings + companyId;
        return this._http.get(route).pipe(map(res => res as any));
    }

    deactivateCompany(company: Company): Observable<Company> {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/json');
        const route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.delete;
        return this._http.put(route, company, this.prepareHeader()).pipe(map(res => res as Company))
    }

    removeCompany(Company: Company): Observable<Company> {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/json');
        const route = environment.RESOURCE_API + environment.apiCatalog.company.subRoutes.remove;
        return this._http.delete(route, { headers: headers, body: Company }).pipe(map(res => res as Company))
    }

    private prepareHeader(): Object {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/json');
        return { headers: headers };
    }
}
